import React, { useRef, useEffect } from 'react';
import { Text } from '@mantine/core';
import * as oauth from '../oauth.js';

const CLIENT_ID = "8896805571";

const TelegramLoginButton = ({ isRussian }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const callbackName = "__tg_oauth_cb_" + Date.now();
    window[callbackName] = (data) => {
      if (data) {
        oauth.TelegramLoginWidgetAuth({
          tgData: data,
          onJWTObtained: () => {
            window.location.href = '/';
          }
        }).catch((err) => {
          console.error('TG OAuth auth failed:', err);
        });
      }
      delete window[callbackName];
    };

    containerRef.current.innerHTML = '';

    const btn = document.createElement('button');
    btn.className = 'tg-auth-button';
    btn.setAttribute('data-style', 'filled');
    btn.textContent = 'Sign In with Telegram';
    containerRef.current.appendChild(btn);

    const script = document.createElement('script');
    script.src = 'https://oauth.telegram.org/js/telegram-login.js?5';
    script.setAttribute('data-client-id', CLIENT_ID);
    script.setAttribute('data-onauth', callbackName + '(data)');
    script.setAttribute('data-request-access', 'write');
    script.async = true;
    containerRef.current.appendChild(script);

    return () => { delete window[callbackName]; };
  }, []);

  return (
    <div>
      <div ref={containerRef} style={{ colorScheme: 'light' }} />
      <Text size="sm" c="blue" ta="center" mt={6}>
        {isRussian
          ? "После подтверждения в Telegram вернитесь на эту вкладку"
          : "After confirming in Telegram, return to this tab"}
      </Text>
    </div>
  );
};

export default TelegramLoginButton;
